module.exports = __webpack_public_path__ + "img/fog_line.66c4b5eb.svg";